import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Sequence from '../views/Sequence.vue'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [{
    path: '/',
    redirect: '/main/sequence',
}, {
    path: '/main/sequence',
    name: 'Sequence',
    component: Sequence,
}]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
})

export default router
